import { render } from "./EditAriklient.vue?vue&type=template&id=3b56bccc&scoped=true"
import script from "./EditAriklient.vue?vue&type=script&lang=js"
export * from "./EditAriklient.vue?vue&type=script&lang=js"

import "./EditAriklient.vue?vue&type=style&index=0&id=3b56bccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b56bccc"]])

export default __exports__